import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';
// import { Stores } from '../../types';
// TODO: Replace "any" with Stores
export var useStores = function () {
  return React.useContext(MobXProviderContext);
};